import { type HgSupportedLanguage } from '@smg-real-estate/domus';
import { type GeoSearchResultItem } from '@smg-real-estate/geo-libs';
import { type SearchHighlights } from '@smg-real-estate/geo-libs/dist/types/geo-api-responses';

export interface HighlightSegment {
  text: string;
  bold?: boolean;
}

export const getHighlightedDisplayValue = (
  geoSearchResultItem: GeoSearchResultItem,
  language: HgSupportedLanguage,
): HighlightSegment[][] => {
  return geoSearchResultItem.geoLocation.names[language].map((name) =>
    getHighlightedNameSegments(name, geoSearchResultItem.highlights),
  );
};

const getHighlightedNameSegments = (
  name: string,
  highlights: SearchHighlights,
): HighlightSegment[] => {
  if (!(name in highlights)) {
    return name ? [{ text: name }] : [];
  }

  const segments: HighlightSegment[] = [];
  let currentIndex = 0;

  for (const { from, to } of highlights[name]) {
    if (isInvalidRange(name, from, to)) {
      continue;
    }

    if (from > currentIndex) {
      segments.push({ text: name.substring(currentIndex, from) });
    }

    segments.push({ text: name.substring(from, to), bold: true });
    currentIndex = to;
  }

  if (currentIndex < name.length) {
    segments.push({ text: name.substring(currentIndex) });
  }

  return segments.length > 0 ? segments : name ? [{ text: name }] : [];
};

const isInvalidRange = (term: string, from: number, to: number): boolean =>
  from < 0 || from > term.length || to < 0 || to > term.length;
